import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { getValidRegexPattern } from 'src/utils/macros/regex';
import TextField from '@mui/material/TextField';
import AddCommonPlaceholderRegex from "src/components/emailConfig/AddCommonPlaceholderRegex";
import Stack from '@mui/material/Stack';

export default function RegexInput({
  id = "default-id",
  name = "default-name",
  label = "",
  regex = "",
  defaultValue = "",
  defaultErrorMessage = "",
  errorMessage = null,
  hasError = null,
  onChangeValue,
  onError,
  required = false,
  readOnly = false,
  disabled = false,
  toValidateRegex = false,
}) {
  const { control } = useForm({
    mode: 'onChange',
    defaultValues: { [name]: defaultValue },
  });

  if (toValidateRegex) {
    return (
      
        <Controller
          name={name}
          control={control}
          rules={{
            validate: (v) => {
              if (!v || String(v).trim() === '') return true;

              const compiled = getValidRegexPattern(v);
              return compiled ? true : (defaultErrorMessage || 'Regex inválido. Verifique a sintaxe.');
            },
          }}
          render={({ field, fieldState }) => (
            <Stack
              spacing={1}
              direction="row"
              alignItems={"center"}
              justifyContent={"center"}
            >
            <TextField
              {...field}
              id={id}
              label={label}
              required={required}
              disabled={disabled}
              inputProps={{ readOnly }}
              variant="outlined"
              fullWidth
              error={Boolean(fieldState?.error)}
              helperText={fieldState?.error?.message}
              onChange={(e) => {
                field.onChange(e);
                if (onChangeValue) onChangeValue(e);
              }}
              onBlur={(e) => {
                field.onBlur(e);
                if (typeof onError === 'function') {
                  const errMsg = fieldState?.error?.message ?? null;
                  onError(errMsg, 'component');
                }
              }}
            />
            <AddCommonPlaceholderRegex
              onChange={(value) => {
                field.onChange(value);
                onChangeValue(value);
              }}
              value={defaultValue}
            />
            </Stack>
          )}
        />
        
      
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        pattern: {
          value: getValidRegexPattern(regex),
          message: (defaultErrorMessage || 'O campo é inválido para o formato definido, verifique antes de continuar.'),
        },
      }}
      render={({ field, fieldState }) => {
        const _hasError = hasError !== undefined && hasError !== null ? hasError : false;
        const _errorMessage = errorMessage !== undefined && errorMessage !== null ? String(errorMessage) : '';

        const computedError = _hasError
          ? Boolean(hasError)
          : Boolean(fieldState?.error);

        const computedHelper = _hasError
          ? _errorMessage
          : fieldState?.error?.message;

        const finalError = _hasError ? computedError : Boolean(fieldState?.error);
        const finalHelperText = _hasError ? computedHelper : fieldState?.error?.message;

        return (
          <TextField
            {...field}
            id={id}
            label={label}
            required={required}
            disabled={disabled}
            inputProps={{ readOnly }}
            variant="outlined"
            fullWidth
            error={finalError}
            helperText={finalHelperText}
            onChange={(e) => {
              field.onChange(e);
              if (onChangeValue) onChangeValue(e);
            }}
            onBlur={(e) => {
              field.onBlur(e);
              const val = field.value;
              if (!val || String(val).trim() === '') return;
              if (typeof onError === 'function') {
                const errMsg = fieldState?.error?.message ?? null;
                onError(errMsg, 'component');
              }
            }}
          />
        );
      }}
    />
  );
}
